/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidacyShow } from '../../axios/candidacyShow'
import type { CandidacyShowError, CandidacyShowPathParams, CandidacyShowResponse } from '../../types/CandidacyShow'

export const candidacyShowQueryKey = (
	organisation: CandidacyShowPathParams['organisation'],
	candidacy: CandidacyShowPathParams['candidacy'],
) => [{
	url: '/candidate-center/organisations/:organisation/candidacies/:candidacy',
	params: { organisation, candidacy },
}] as const

export type CandidacyShowQueryKey = ReturnType<typeof candidacyShowQueryKey>

/** @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidacyController.php CandidacyController::show */
export function candidacyShowQueryOptions(
	organisation: CandidacyShowPathParams['organisation'],
	candidacy: CandidacyShowPathParams['candidacy'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CandidacyShowResponse,
		AxiosError<CandidacyShowError>,
		CandidacyShowResponse,
		CandidacyShowQueryKey
	>({
		queryKey: candidacyShowQueryKey(organisation, candidacy),
		queryFn: ({ signal }) => candidacyShow(organisation, candidacy, { signal, ...config }).then(res => res.data),
		enabled: !!(organisation && candidacy),
	})
}

/** @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidacyController.php CandidacyController::show */
export function useCandidacyShow<TSelectData = CandidacyShowResponse>(
	organisation: CandidacyShowPathParams['organisation'],
	candidacy: CandidacyShowPathParams['candidacy'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CandidacyShowResponse,
					AxiosError<CandidacyShowError>,
					TSelectData,
					CandidacyShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CandidacyShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...candidacyShowQueryOptions(organisation, candidacy),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidacyController.php CandidacyController::show */
export function useCandidacyShowSuspense<TSelectData = CandidacyShowResponse>(
	organisation: CandidacyShowPathParams['organisation'],
	candidacy: CandidacyShowPathParams['candidacy'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CandidacyShowResponse,
					AxiosError<CandidacyShowError>,
					TSelectData,
					CandidacyShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CandidacyShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...candidacyShowQueryOptions(organisation, candidacy),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
